import { Injectable } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { NestApiProvider } from "../../../shared/nestjs/nest-api";
import { SkillSf6Api } from "../../../shared/nestjs/gd-integrated/services/skill.api";
import { ResponseSaveDto } from "../../../shared/nestjs/gd-integrated/dto/skill.dto";
import { NestResponsesProvider } from "../../../shared/nestjs/nest-responses";
import { Interestf6Api } from "../../../shared/nestjs/gd-integrated/services/interest.api";
import { EmploymentInfoSf6Api } from "../../../shared/nestjs/gd-integrated/services/employment-info-sf6.api";
import { OhsaHistorySf6Api } from "../../../shared/nestjs/gd-integrated/services/ohsa-history-sf6.api";
import { PersonalNestApi } from "../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../providers/global-service/global-service";
import { CustomFieldSf6Api } from "../../../shared/nestjs/gd-integrated/services/custom-field-sf6.api";

@Injectable()
export class ProfileSf6Bloc {

	private subscriptions: Array<Subscription> = [];
	constructor(
		public nestApiProvider: NestApiProvider,
		private skillSf6Api: SkillSf6Api,
		public nestResponse: NestResponsesProvider,		
		public interestf6Api : Interestf6Api,
		public employmentInfoSf6Api: EmploymentInfoSf6Api,
		public ohsaHistorySf6Api: OhsaHistorySf6Api,
		public personalApi: PersonalNestApi,    
		public globalService: GlobalServiceProvider,
		public customFieldSf6Api: CustomFieldSf6Api
	) { }

	/**
	 * Skill
	 */	

	saveSkill(data): Observable<ResponseSaveDto> {
		return this.skillSf6Api.save(data);
	}

	listingSkill(payload): Observable<any> {
		return this.skillSf6Api.listing(
			payload.empId, payload.lang
		);
	}

	async getTypeSkill(payload) {
		return new Promise<any>(async (resolve, reject) => {
			this.subscriptions.push(
				this.skillSf6Api.type(payload).subscribe(result => {
					let skillTypeList = [];
					if (result.data) {
						let objTemplate = {
							code: '0',
							name: 'Select',
							orderNo: 0
						}
						skillTypeList.push(objTemplate)
					
					for (const val of result.data) {
						let obj = {
							code: val.code,
							name: val.name,
							orderNo: val.orderNo
						}
						skillTypeList.push(obj)
						}
					}
					resolve(skillTypeList);
				}, error => {
					reject(error)
					console.log("error", error);
				})
			)
		})
	}

	/**
	 * Interest
	 */	

	saveInterest(data): Observable<ResponseSaveDto> {
		return this.interestf6Api.save(data);
	}

	listingInterest(payload): Observable<any> {
		return this.interestf6Api.listing(
			payload.empId, payload.lang
		);
	}

	async getTypeInterest(payload) {
		return new Promise<any>(async (resolve, reject) => {
			this.subscriptions.push(
				this.interestf6Api.type(payload).subscribe(result => {
					let interestTypeList = [];
					if (result.data) {
						let objTemplate = {
							code: '0',
							name: 'Select',
							orderNo: 0
						}
						interestTypeList.push(objTemplate)
					
					for (const val of result.data) {
						let obj = {
							code: val.code,
							name: val.name,
							orderNo: val.orderNo
						}
						interestTypeList.push(obj)
						}
					}
					resolve(interestTypeList);
				}, error => {
					reject(error)
					console.log("error interestTypeList", error);
				})
			)
		})
	}

	/**
	 * Employment Info
	 */	

	detailEmploymentInfo(payload): Observable<any> {
		console.log('employement info', payload)
		return this.employmentInfoSf6Api.detail(
			payload.empId
		);
	}

	/**
	 * OHSA History
	 */	

	listingOHSA(payload): Observable<any> {
		console.log('employement info', payload)
		return this.ohsaHistorySf6Api.listing(
			payload.empId
		);
	}

	getPersonal(payload): Promise<any> {
		return new Promise((resolve, reject) => {
		  this.personalApi.getPersonal(payload).subscribe(
			async (result) => {
			  console.log('BLOC | getPersonal', result)
			  let resultData = await this.globalService.convertObjToCamelCase(result.data);
			  resolve(resultData);
			}, error => {
			  reject(error);
			  console.log('getPersonal', error)
			}
		  )
		})
	}

	/**
	 * CUSTOM FIELD
	 */	

	listingCustomField(payload): Observable<any> {
		console.log('CUSTOM FIELD', payload)
		return this.customFieldSf6Api.listing(
			payload.empId
		);
	}

	saveCustomField(data): Observable<any> {
		return this.customFieldSf6Api.save(data);
	}
}



// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-sf6.bloc.ts